export { default } from './TwoColumnsSection.component';
